import { Route, Routes } from "react-router-dom";
import Master from "./Master";

export default function MasterRouter() {
  return (
    <Routes>
      <Route path="/" element={<Master />} />
    </Routes>
  );
}
